// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hILj","title":"Info_title__o2v6p","selects":"Info_selects__WBJ4e","requiredAsterisk":"Info_requiredAsterisk__3cogz"};